import {ActionReducer, Action} from '@ngrx/store';
import {AppState} from './interfaces/app-state';

// Actions
import {
    DISPLAY_NAVIGATION_MENU,
    HIDE_NAVIGATION_MENU,
    DISPLAY_START_ARROW,
    HIDE_START_ARROW,
    DISPLAY_PRODUCT_DETAILS_MODAL,
    HIDE_PRODUCT_DETAILS_MODAL,
    DISPLAY_PRINT_SUMMARY_MODAL,
    HIDE_PRINT_SUMMARY_MODAL,
    DISPLAY_EMAIL_SUMMARY_MODAL,
    DISPLAY_ALERT_MODAL,
    HIDE_EMAIL_SUMMARY_MODAL,
    HIDE_ALERT_MODAL,
    DISPLAY_ONLY_DROPDOWN,
    DISPLAY_ALL_CONTENT,
    DISPLAY_OPTIONS_MENU,
    HIDE_OPTIONS_MENU,
    DISPLAY_PREVIEW,
    HIDE_PREVIEW
} from './app-actions';

let debug, debugOff = function (...any) { };
process.env.NODE_ENV !== 'production' && (debug = require('debug')('app:SummaryPageCmp'));

export const AppReducer: ActionReducer<any> = (state: AppState, action: Action) => {

    // Each new pass on the reducer creates new state object
    let newState;

    switch (action.type) {

        case DISPLAY_NAVIGATION_MENU:
            newState = Object.assign( {}, state, {navigationMenuIsVisible: true} );
            // 'DISPLAY_NAVIGATION_MENU:', [action, newState] );
            return newState;

        case HIDE_NAVIGATION_MENU:
            newState = Object.assign( {}, state, {navigationMenuIsVisible: false} );
            // 'HIDE_NAVIGATION_MENU:', [action, newState] );
            return newState;

        case DISPLAY_START_ARROW:
            newState = Object.assign( {}, state, {startArrowIsVisible: true} );
            // 'DISPLAY_START_ARROW:', [action, newState] );
            return newState;

        case HIDE_START_ARROW:
            newState = Object.assign( {}, state, {startArrowIsVisible: false} );
            // 'HIDE_START_ARROW:', [action, newState] );
            return newState;

        case DISPLAY_PRODUCT_DETAILS_MODAL:
            newState = Object.assign( {}, state, {productDetailsModalIsVisible: true} );
            // 'DISPLAY_PRODUCT_DETAILS_MODAL:', [action, newState] );
            return newState;

        case HIDE_PRODUCT_DETAILS_MODAL:
            newState = Object.assign( {}, state, {productDetailsModalIsVisible: false} );
            // 'HIDE_PRODUCT_DETAILS_MODAL:', [action, newState] );
            return newState;

        case DISPLAY_PRINT_SUMMARY_MODAL:
            newState = Object.assign( {}, state, {printSummaryModalIsVisible: true} );
            // 'DISPLAY_PRINT_SUMMARY_MODAL:', [action, newState] );
            return newState;

        case HIDE_PRINT_SUMMARY_MODAL:
            newState = Object.assign( {}, state, {printSummaryModalIsVisible: false} );
            // 'HIDE_PRINT_SUMMARY_MODAL:', [action, newState] );
            return newState;

        case DISPLAY_EMAIL_SUMMARY_MODAL:
            newState = Object.assign( {}, state, {emailSummaryModalIsVisible: true} );
            // 'DISPLAY_EMAIL_SUMMARY_MODAL:', [action, newState] );
            return newState;

        case HIDE_EMAIL_SUMMARY_MODAL:
            newState = Object.assign( {}, state, {emailSummaryModalIsVisible: false} );
            // 'HIDE_EMAIL_SUMMARY_MODAL:', [action, newState] );
            return newState;

        case DISPLAY_ALERT_MODAL:
            newState = Object.assign( {}, state, {alertModalIsVisible: true} );
            // 'DISPLAY_ALERT_MODAL:', [action, newState] );
            return newState;

        case HIDE_ALERT_MODAL:
            newState = Object.assign( {}, state, {alertModalIsVisible: false} );
            // 'HIDE_ALERT_MODAL:', [action, newState] );
            return newState;

        case DISPLAY_ONLY_DROPDOWN:
            newState = Object.assign( {}, state, {onlyDropdownIsVisible: true} );
            // 'DISPLAY_ONLY_DROPDOWN:', [action, newState] );
            return newState;

        case DISPLAY_ALL_CONTENT:
            newState = Object.assign( {}, state, {onlyDropdownIsVisible: false} );
            // 'DISPLAY_ALL_CONTENT:', [action, newState] );
            return newState;

        case DISPLAY_OPTIONS_MENU:
            newState = Object.assign( {}, state, {optionsMenuIsVisible: true} );
            // 'DISPLAY_OPTIONS_MENU:', [action, newState] );
            return newState;

        case HIDE_OPTIONS_MENU:
            newState = Object.assign( {}, state, {optionsMenuIsVisible: false} );
            // 'HIDE_OPTIONS_MENU:', [action, newState] );
            return newState;

        case DISPLAY_PREVIEW:
            newState = Object.assign( {}, state, {previewIsVisible: true} );
            // 'DISPLAY_PREVIEW:', [action, newState] );
            return newState;

        case HIDE_PREVIEW:
            newState = Object.assign( {}, state, {previewIsVisible: false} );
            // 'HIDE_PREVIEW:', [action, newState] );
            return newState;

        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/shared/state/app-reducer.ts